// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";

// export default function QuizRound() {
//   const navigate = useNavigate();
//   const [quizName, setQuizName] = useState("Round2");
//   const [jobcode, setJobcode] = useState("TESTSHO");
//   const [userId, setUserId] = useState(8034);
//   const [questionsAns, setQuestionsAns] = useState([
//     {
//       questionId: 1,
//       optionsId: 1,
//     },
//   ]);

//   const handleSubmit = () => {
//     const payload = {
//       quizName,
//       jobcode,
//       userId,
//       questionsAns,
//     };
//     console.log("Submitted Payload:", payload);
//     // Add your API call here
//   };

//   return (
//     <div className="max-w-md mx-auto   border rounded shadow-md bg-white " style={{padding:"70px"}}>
//       <div className="mb-4 inpt-flx">
//         <label className="block text-sm font-semibold text-gray-700 mb-1"   >
//           quiz Size
//         </label>
//         <input
//           value={quizName}
//           onChange={(e) => setQuizName(e.target.value)}
//           className="w-full border border-gray-300 rounded px-3 py-2"
//           style={{fontSize:"14px"}}
//         />
//       </div>

//       <div className="mb-4 inpt-flx">
//         <label className="block text-sm font-semibold text-gray-700 mb-1"   style={{fontSize:"14px"}}>
//           Job code
//         </label>
//         <input
//           value={jobcode}
//           onChange={(e) => setJobcode(e.target.value)}
//           className="w-full border border-gray-300 rounded px-3 py-2"
//           style={{fontSize:"14px"}}
//         />
//       </div>

//       <div className="mb-4 inpt-flx">
//         <label className="block text-sm font-semibold text-gray-700 mb-1"   style={{fontSize:"14px"}}>
//         Email
//         </label>
//         <input
//     type="email"
//     value={userId}
//     onChange={(e) => setUserId(e.target.value)}
//     className="w-full border border-gray-300 rounded px-3 py-2"
//     style={{ fontSize: "14px" }}
//   />
//       </div>

//       {/* questionsAns section */}
//       <div className="mb-4 inpt-flx">
//         <label className="block text-sm font-semibold text-gray-700 mb-1">
//          <strong>Question</strong> 
//         </label>

//         <div className="mt-3 inpt-flx">
//           <label className="block text-sm mb-1"   style={{fontSize:"14px"}}>Question 1</label>
//           <input
//     type="question1"
    
   
//     className="w-full border border-gray-300 rounded px-3 py-2"
//     style={{ fontSize: "14px" }}
//   />

//           <label className="block text-sm mb-1"   style={{fontSize:"14px"}}>Question 2</label>
//           <input
//     type="question2"
   
//     className="w-full border border-gray-300 rounded px-3 py-2"
//     style={{ fontSize: "14px" }}
//   />
//         </div>
//       </div>

//       <div style={{display:"flex",justifyContent:"center"}}>         <button
//        onClick={() => navigate("/Quizthankyou")}
//         //  onClick={handleSubmit}
//          className="w-full  but_submit_lywo1"      >
//          Submit
//        </button>
//        </div>
//     </div>

//   );
// }
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function QuizRound() {
  const navigate = useNavigate();
  const [quizName, setQuizName] = useState("Round2");
  const [jobcode, setJobcode] = useState("TESTSHO");
  const [userId, setUserId] = useState(8034);
  const [questionsAns, setQuestionsAns] = useState([
    {
      questionId: 1,
      optionsId: 1,
    },
  ]);

  const handleSubmit = () => {
    const payload = {
      quizName,
      jobcode,
      userId,
      questionsAns,
    };
    console.log("Submitted Payload:", payload);
    // Add your API call here
  };

  return (
    <div 
      className="max-w-md mx-auto border rounded shadow-md bg-white"
      style={{
        padding: "70px",
      }}
    >
      {/* Decorative elements */}
      <div style={{
        position: "absolute",
        top: 0,
        right: 0,
        width: "100px",
        height: "100px",
        background: "blue",
        clipPath: "circle(50% at 100% 0)",
        opacity: 0.1
      }}></div>
      
      <div style={{
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "80px",
        height: "80px",
        background: "linear-gradient(45deg, #10b981, #34d399)",
        clipPath: "circle(50% at 0 100%)",
        opacity: 0.1
      }}></div>

      <h2 style={{
        fontSize: "24px",
        fontWeight: "600",
        color: "#111827",
        marginBottom: "30px",
        textAlign: "center",
        position: "relative"
      }}>
        Quiz Submission
        <div style={{
          width: "60px",
          height: "3px",
          background: "linear-gradient(to right, #4f46e5, #7c3aed)",
          margin: "10px auto 0",
          borderRadius: "3px"
        }}></div>
      </h2>

      <div className="mb-4 inpt-flx" style={{ position: "relative" }}>
        <label className="block text-sm font-semibold text-gray-700 mb-1" style={{ fontSize: "14px" }}>
          Quiz Size
        </label>
        <input
          value={quizName}
          onChange={(e) => setQuizName(e.target.value)}
          className="w-full border border-gray-300 rounded px-3 py-2"
          style={{
            fontSize: "14px",
            borderColor: "#e5e7eb",
            transition: "all 0.3s ease",
           
            padding: "10px 15px",
            borderRadius: "8px"
          }}
          onFocus={(e) => {
            e.target.style.borderColor = "#4f46e5";
            e.target.style.boxShadow = "0 0 0 3px rgba(79, 70, 229, 0.1)";
          }}
          onBlur={(e) => {
            e.target.style.borderColor = "#e5e7eb";
            e.target.style.boxShadow = "none";
          }}
        />
      </div>

      <div className="mb-4 inpt-flx" style={{ position: "relative" }}>
        <label className="block text-sm font-semibold text-gray-700 mb-1" style={{ fontSize: "14px" }}>
          Job code
        </label>
        <input
          value={jobcode}
          onChange={(e) => setJobcode(e.target.value)}
          className="w-full border border-gray-300 rounded px-3 py-2"
          style={{
            fontSize: "14px",
            borderColor: "#e5e7eb",
            transition: "all 0.3s ease",
           
            padding: "10px 15px",
            borderRadius: "8px"
          }}
          onFocus={(e) => {
            e.target.style.borderColor = "#4f46e5";
            e.target.style.boxShadow = "0 0 0 3px rgba(79, 70, 229, 0.1)";
          }}
          onBlur={(e) => {
            e.target.style.borderColor = "#e5e7eb";
            e.target.style.boxShadow = "none";
          }}
        />
      </div>

      <div className="mb-4 inpt-flx" style={{ position: "relative" }}>
        <label className="block text-sm font-semibold text-gray-700 mb-1" style={{ fontSize: "14px" }}>
          Email
        </label>
        <input
          type="email"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
          className="w-full border border-gray-300 rounded px-3 py-2"
          style={{
            fontSize: "14px",
            borderColor: "#e5e7eb",
            transition: "all 0.3s ease",
          
            padding: "10px 15px",
            borderRadius: "8px"
          }}
          onFocus={(e) => {
            e.target.style.borderColor = "#4f46e5";
            e.target.style.boxShadow = "0 0 0 3px rgba(79, 70, 229, 0.1)";
          }}
          onBlur={(e) => {
            e.target.style.borderColor = "#e5e7eb";
            e.target.style.boxShadow = "none";
          }}
        />
      </div>

      {/* questionsAns section */}
      <div className="mb-6 inpt-flx" style={{ position: "relative" }}>
        <label className="block text-sm font-semibold text-gray-700 mb-2" style={{ fontSize: "14px" }}>
          <strong>Question Answers</strong>
        </label>

        <div 
          className="mt-3 inpt-flx"
          
        >
          <label className="block text-sm mb-1" style={{ fontSize: "14px", color: "#4b5563" }}>Question 1</label>
          <input
            type="text"
            className="w-full border border-gray-300 rounded px-3 py-2"
            style={{
              fontSize: "14px",
              marginBottom: "15px",
              borderColor: "#e5e7eb",
              transition: "all 0.3s ease",
           
              padding: "10px 15px",
              borderRadius: "8px"
            }}
            onFocus={(e) => {
              e.target.style.borderColor = "#4f46e5";
              e.target.style.boxShadow = "0 0 0 3px rgba(79, 70, 229, 0.1)";
            }}
            onBlur={(e) => {
              e.target.style.borderColor = "#e5e7eb";
              e.target.style.boxShadow = "none";
            }}
          />

          <label className="block text-sm mb-1" style={{ fontSize: "14px", color: "#4b5563" }}>Question 2</label>
          <input
            type="text"
            className="w-full border border-gray-300 rounded px-3 py-2"
            style={{
              fontSize: "14px",
              borderColor: "#e5e7eb",
              transition: "all 0.3s ease",
          
              padding: "10px 15px",
              borderRadius: "8px"
            }}
            onFocus={(e) => {
              e.target.style.borderColor = "#4f46e5";
              e.target.style.boxShadow = "0 0 0 3px rgba(79, 70, 229, 0.1)";
            }}
            onBlur={(e) => {
              e.target.style.borderColor = "#e5e7eb";
              e.target.style.boxShadow = "none";
            }}
          />
        </div>
      </div>

      <div style={{display:"flex",justifyContent:"center"}} className="mt-3">         <button
       onClick={() => navigate("/Quizthankyou")}
        //  onClick={handleSubmit}
         className="w-full  but_submit_lywo1"      >
         Submit
       </button>
       </div>
    </div>
  );
}